import { SubmissionResult } from "./subTypes";

export function getSubmissionExplanation(result: SubmissionResult): string {
  switch (result.type) {
    case "passed":
      return "Your code passed all our tests. Way to go!";
    case "failed":
      return `Your code failed one of our tests. See below for more details on what went wrong.`;
    case "error":
      return "There was an error while running your code. Please check your code and try again.";
    case "timeout":
      return "Your code execution timed out. It may be stuck in an infinite loop or taking too long to complete.";
    case "incomplete":
      return "Your submission is still being processed. Please wait a moment and check back.";
    case "unknown":
    default:
      return "The result of your submission is unknown. Please try again.";
  }
}

export function getResultText(result: SubmissionResult): string {
  switch (result.type) {
    case "incomplete":
      return getProgressText(result);
    case "passed":
      return "Submission Passed";
    case "failed":
      return "Submission Failed";
    case "error":
      return "Submission Error";
    case "timeout":
      return "Submission Timeout";
    case "unknown":
    default:
      return "Submission In Testing";
  }
}

function getProgressText(result: SubmissionResult): string {
  if (result.type === "incomplete") {
    switch (result.progress) {
      case "submitted":
        return "Code Submitted";
      case "blocked":
        return "Waiting for Resources";
      case "running":
        return "Tests Running";
      case "complete":
        return "Tests Complete";
      default:
        return "In Testing";
    }
  }
  return "";
}
